(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/prescript.js');

var svs = svs || {};

(function(svs) {
  svs.app = svs.app || {};
  svs.app.productStartPage = svs.app.productStartPage || {};
  svs.app.productStartPage.promos = svs.app.productStartPage.promos || {};
  svs.app.productStartPage.promos.views =
    svs.app.productStartPage.promos.views || {};
  svs.app.productStartPage.tabs = svs.app.productStartPage.tabs || {};
  svs.app.productStartPage.tabs.views =
    svs.app.productStartPage.tabs.views || {};
  svs.app.productStartPage.rounds = svs.app.productStartPage.rounds || {};
  svs.app.productStartPage.rounds.views =
    svs.app.productStartPage.rounds.views || {};
  svs.app.productStartPage.footer = svs.app.productStartPage.footer || {};
  svs.app.productStartPage.footer.views =
    svs.app.productStartPage.footer.views || {};
})(svs);


 })(window);